<template><div><h1 id="_1-adressaktualisierung" tabindex="-1"><a class="header-anchor" href="#_1-adressaktualisierung"><span>1. Adressaktualisierung</span></a></h1>
<p>Daten, insbesondere Adressdaten, können bei externen Anbietern gepflegt werden. funtrade bietet dazu eine Schnittstelle. Die Schnittstelle unterstützt zurzeit die folgenden Aktualisierungsdienste:</p>
<table>
<thead>
<tr>
<th>Aktualisierungsdienst</th>
<th>Abgleich von Fremdadressen</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adresspflege Online</td>
<td>ja</td>
</tr>
<tr>
<td>Adresspflege über Webservice</td>
<td>nein</td>
</tr>
<tr>
<td>CRIF</td>
<td>nein</td>
</tr>
<tr>
<td>Matchmove</td>
<td>ja</td>
</tr>
<tr>
<td>Multisource</td>
<td>nein</td>
</tr>
</tbody>
</table>
<h2 id="_1-1-aktualisierungsdienst-adresspflege-online" tabindex="-1"><a class="header-anchor" href="#_1-1-aktualisierungsdienst-adresspflege-online"><span>1.1. Aktualisierungsdienst Adresspflege Online</span></a></h2>
<p>Die Schnittstelle Adresspflege Online der Post erlaubt das Abgleichen einer Menge von Adressen bei der Post. Z.B. kann man die Retouren eines Mailings in einem Filter selektieren und dann bei der Post abgleichen.</p>
<p>Vor der Verwendung muss ein entsprechender Vertrag mit der Post bestehen. Für die Historisierung (Ereignis) muss der Systemparameter &quot;mmov&quot; und &quot;mmof&quot; definiert werden.</p>
<p><strong>Prozedur 8.1. Abgleich von Adressen mit Adresspflege Online</strong></p>
<ol>
<li>
<p>Filter definieren</p>
<p>Für den Abgleich der Adressen muss vorgängig ein Filter für die Selektion der abzugleichenden Adressen definiert werden.</p>
</li>
<li>
<p>Filter markieren</p>
<p>Der definierte Filter muss für den Export vorher markiert sein.</p>
</li>
<li>
<p>Aktualisierungsdienst auswählen</p>
<p>Für den Abgleich der Adressen mit Adresspflege Online muss unter Adressaktualisierung der Aktualisierungsdienst Adresspflege Online ausgewählt werden.</p>
</li>
<li>
<p>Filter auswählen</p>
<p>Vorgängig definierten Filter auswählen</p>
</li>
<li>
<p>Job für Export der Adressen starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> wählen.</p>
</li>
<li>
<p>Adressen exportieren</p>
<p>Mit OK werden die im Filter enthaltenen Adressen in eine File exportiert, siehe Exportdatei.</p>
</li>
<li>
<p>Adressen abgleichen</p>
<p>Der Abgleich wird ausserhalb von funtrade durchgeführt.</p>
</li>
<li>
<p>Job für Import der Abgleichsresultate starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink> wählen.</p>
</li>
<li>
<p>Abgleichsresultate importieren</p>
<p>Im Feld &quot;Abgleichsresultat&quot; das Abgleichsfile von Adresspflege Online wählen.</p>
<p>Mit OK werden die Importdateien (abgeglichene Adressen) importiert.</p>
<p>Mit dem Switch &quot;Einlesen&quot; können die Files als Test zur Kontrolle oder definitiv eingelesen werden.</p>
</li>
</ol>
<h2 id="_1-2-aktualisierungsdienst-adresspflege-uber-webservice" tabindex="-1"><a class="header-anchor" href="#_1-2-aktualisierungsdienst-adresspflege-uber-webservice"><span>1.2. Aktualisierungsdienst Adresspflege über Webservice</span></a></h2>
<p>Die Schnittstelle Adresspflege über Webservice der Post erlaubt das Abgleichen einer Menge von Adressen bei der Post. Z.B. kann man die Retouren eines Mailings in einem Filter selektieren und dann bei der Post abgleichen.</p>
<p>Vor der Verwendung muss ein entsprechender Vertrag mit der Post bestehen.</p>
<p>Der Account bei der Post muss dann in der Datei SiteConfiguration.xml mit folgendem Syntax definiert werden:</p>
<div class="language-properties line-numbers-mode" data-highlighter="prismjs" data-ext="properties"><pre v-pre><code><span class="line"><span class="token key attr-name">&lt;!--</span> <span class="token value attr-value">Adressaktualisierung Web-Services Post --></span></span>
<span class="line"><span class="token key attr-name">&lt;property</span> <span class="token value attr-value">name="AdressAbgleich-WS-Post-url">​https://webservices.post.ch/IN\_SYNSYN\_EXT/v1​&lt;/property></span></span>
<span class="line"><span class="token key attr-name">&lt;property</span> <span class="token value attr-value">name="AdressAbgleich-WS-Post-username">USER&lt;/property></span></span>
<span class="line"><span class="token key attr-name">&lt;property</span> <span class="token value attr-value">name="AdressAbgleich-WS-Post-passwort">PASSWORT&lt;/property></span></span>
<span class="line"><span class="token key attr-name">&lt;property</span> <span class="token value attr-value">name="AdressAbgleich-WS-Post-key">arenae\_v1&lt;/property></span></span>
<span class="line">      </span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Für die Historisierung (Ereignis) muss der Systemparameter &quot;mmov&quot; und &quot;mmof&quot; definiert werden.</p>
<p><strong>Prozedur 8.2. Abgleich von Adressen bei der Post</strong></p>
<ol>
<li>
<p>Filter definieren</p>
<p>Für den Abgleich der Adressen muss vorgängig ein Filter für die Selektion der abzugleichenden Adressen definiert werden.</p>
</li>
<li>
<p>Filter markieren</p>
<p>Der definierte Filter muss für den Export vorher markiert sein.</p>
</li>
<li>
<p>Aktualisierungsdienst auswählen</p>
<p>Für den Abgleich der Adressen mit Adresspflege über Webservice muss unter Adressaktualisierung der Aktualisierungsdienst Adresspflege über Webservice ausgewählt werden.</p>
</li>
<li>
<p>Filter auswählen</p>
<p>Vorgängig definierten Filter auswählen</p>
</li>
<li>
<p>Job für Export der Adressen starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> wählen.</p>
</li>
<li>
<p>Adressen exportieren</p>
<p>Mit OK werden die im Filter enthaltenen Adressen zur Post exportiert und abgeglichen.</p>
<p>Der Abgleich kann je nach Menge der Adressen eine weile dauern. Anhand des Status ist erkennbar wann der Abgleich abgeschlossen ist (Adressabgleich erfolgreich beendet).</p>
</li>
<li>
<p>Job für Import der Abgleichsresultate starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink> wählen.</p>
</li>
<li>
<p>Abgleichsresultate importieren</p>
<p>Mit OK werden die Importdateien (abgeglichene Adressen) importiert.</p>
<p>Mit dem Switch &quot;Einlesen&quot; können die Files als Test zur Kontrolle oder definitiv eingelesen werden.</p>
</li>
</ol>
<h2 id="_1-3-aktualisierungsdienst-crif" tabindex="-1"><a class="header-anchor" href="#_1-3-aktualisierungsdienst-crif"><span>1.3. Aktualisierungsdienst CRIF</span></a></h2>
<p>Die CRIF Batch Schnittstelle erlaubt das Abgleichen einer Menge von Adressen bei CRIF. Z.B. kann man die Retouren eines Mailings in einem Filter selektieren und dann bei CRIF abgleichen.</p>
<p>Vor der Verwendung muss ein entsprechender Vertrag mit CRIF bestehen. Der Account bei CRIF muss dann im Systemparameter &quot;CRIF-Params&quot; hinterlegt werden. Für die Historisierung (Ereignis) muss zudem der Systemparameter &quot;crif&quot; definiert werden.</p>
<p><strong>Prozedur 8.3. Abgleich von Adressen bei CRIF</strong></p>
<ol>
<li>
<p>Filter definieren</p>
<p>Für den Abgleich der Adressen muss vorgängig ein Filter für die Selektion der abzugleichenden Adressen definiert werden.</p>
</li>
<li>
<p>Filter markieren</p>
<p>Der definierte Filter muss für den Export vorher markiert sein.</p>
</li>
<li>
<p>Aktualisierungsdienst auswählen</p>
<p>Für den Abgleich der Adressen mit CRIF muss unter Adressaktualisierung der Aktualisierungsdienst CRIF ausgewählt werden.</p>
</li>
<li>
<p>Filter auswählen</p>
<p>Vorgängig definierten Filter auswählen</p>
</li>
<li>
<p>Job für Export der Adressen starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> wählen.</p>
</li>
<li>
<p>Adressen exportieren</p>
<p>Mit OK werden die im Filter enthaltenen Adressen zu CRIF exportiert und abgeglichen.</p>
<p>Der Abgleich kann je nach Menge der Adressen eine weile dauern. Anhand des Status ist erkennbar wann der Abgleich abgeschlossen ist (Adressabgleich erfolgreich beendet).</p>
</li>
<li>
<p>Job für Import der Abgleichsresultate starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink> wählen.</p>
</li>
<li>
<p>Abgleichsresultate importieren</p>
<p>Mit OK werden die Importdateien (abgeglichene Adressen) importiert.</p>
<p>Mit dem Switch &quot;Einlesen&quot; können die Files als Test zur Kontrolle oder definitiv eingelesen werden.</p>
</li>
</ol>
<h3 id="_1-3-1-systemreaktionen-pro-status" tabindex="-1"><a class="header-anchor" href="#_1-3-1-systemreaktionen-pro-status"><span>1.3.1. Systemreaktionen pro Status</span></a></h3>
<p>Generell kann pro Status ein Ereignis für den Adressabgleich erfasst werden (in Tabelle <RouteLink to="/referenz/refs/ft.refdata.adressaktualisierungparam.html" title="Adressaktualisierung Parametrisierung">Parametrisierung Adressaktualisierung</RouteLink>)</p>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
<th>Aktion in funtrade</th>
</tr>
</thead>
<tbody>
<tr>
<td>umzug</td>
<td>offizieller Umzug</td>
<td><br>erfasst eine neue Standardadresse<br>Reaktivierung der Personensperre, wenn Person als verstorben erfasst ist (Aktivierungsereignis, Typ A)</td>
</tr>
<tr>
<td>verstorben</td>
<td>Person ist verstorben</td>
<td>erfasst Personen-Sperre XG oder XT (falls nicht schon vorhanden)</td>
</tr>
<tr>
<td>identity-high</td>
<td>Person gefunden (hoch)</td>
<td>Reaktivierung, wenn Adresssperre erfasst ist (Aktivierungsereignis, Typ A)</td>
</tr>
<tr>
<td>identity-medium</td>
<td>Person gefunden (mittel)</td>
<td>Reaktivierung, wenn Adresssperre erfasst ist (Aktivierungsereignis, Typ A)</td>
</tr>
<tr>
<td>identity-low</td>
<td>Person gefunden (niedrig)</td>
<td>Reaktivierung, wenn Adresssperre erfasst ist (Aktivierungsereignis, Typ A)</td>
</tr>
<tr>
<td>identity-Identity</td>
<td>Person gefunden (in unterschiedlichem Haus, Strasse, Ort)</td>
<td>Reaktivierung, wenn Adresssperre erfasst ist (Aktivierungsereignis, Typ A)</td>
</tr>
<tr>
<td>identityWithConflictingHouse</td>
<td>Person gefunden (in unterschiedlichem Haus)</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
<tr>
<td>identityWithConflictingStreet</td>
<td>Person gefunden (an unterschiedlicher Strasse)</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
<tr>
<td>identityWithConflictingCity</td>
<td>Person gefunden (in unterschiedlichem Ort)</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
<tr>
<td>lastNameInHouse</td>
<td>Nur Nachname im Haus gefunden</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
<tr>
<td>houseConfirmed</td>
<td>Haus, Strasse, Ort verifiziert</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
<tr>
<td>streetConfirmed</td>
<td>Strasse, Ort verifiziert (Haus nicht verifiziert)</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
<tr>
<td>cityConfirmed</td>
<td>Ort verifiziert (Haus, Strasse nicht verifiziert)</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
<tr>
<td>notConfirmed</td>
<td>Nichts verifiziert</td>
<td>keine Aktion, nur Protokollierung</td>
</tr>
</tbody>
</table>
<h2 id="_1-4-aktualisierungsdienst-matchmove" tabindex="-1"><a class="header-anchor" href="#_1-4-aktualisierungsdienst-matchmove"><span>1.4. Aktualisierungsdienst Matchmove</span></a></h2>
<p>Die Schnittstelle Matchmove erlaubt das Abgleichen einer Menge von Adressen mit Matchmove. Z.B. kann man die Retouren eines Mailings in einem Filter selektieren und dann mit Matchmove abgleichen.</p>
<p>Vor der Verwendung muss ein entsprechender Vertrag mit Matchmove (Post) bestehen. Für die Historisierung (Ereignis) muss der Systemparameter &quot;mmov&quot; und &quot;mmof&quot; definiert werden.</p>
<p><strong>Prozedur 8.4. Abgleich von Adressen mit Matchmove</strong></p>
<ol>
<li>
<p>Filter definieren</p>
<p>Für den Abgleich der Adressen muss vorgängig ein Filter für die Selektion der abzugleichenden Adressen definiert werden.</p>
</li>
<li>
<p>Filter markieren</p>
<p>Der definierte Filter muss für den Export vorher markiert sein.</p>
</li>
<li>
<p>Aktualisierungsdienst auswählen</p>
<p>Für den Abgleich der Adressen mit Matchmove muss unter Adressaktualisierung der Aktualisierungsdienst Matchmove ausgewählt werden.</p>
</li>
<li>
<p>Filter auswählen</p>
<p>Vorgängig definierten Filter auswählen</p>
</li>
<li>
<p>Job für Export der Adressen starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> wählen.</p>
</li>
<li>
<p>Adressen exportieren</p>
<p>Mit OK werden die im Filter enthaltenen Adressen in eine File exportiert, siehe Exportdatei.</p>
</li>
<li>
<p>Adressen abgleichen</p>
<p>Der Abgleich wird ausserhalb von funtrade durchgeführt.</p>
</li>
<li>
<p>Job für Import der Abgleichsresultate starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink> wählen.</p>
</li>
<li>
<p>Abgleichsresultate importieren</p>
<p>Im Feld &quot;Abgleichsresultat&quot; das Abgleichsfile von Matchmove wählen.</p>
<p>Mit OK werden die Importdateien (abgeglichene Adressen) importiert.</p>
<p>Mit dem Switch &quot;Einlesen&quot; können die Files als Test zur Kontrolle oder definitiv eingelesen werden.</p>
</li>
</ol>
<h2 id="_1-5-aktualisierungsdienst-multisource" tabindex="-1"><a class="header-anchor" href="#_1-5-aktualisierungsdienst-multisource"><span>1.5. Aktualisierungsdienst Multisource</span></a></h2>
<p>Die Multisource Schnittstelle erlaubt das Abgleichen einer Menge von Adressen mit Multisource. Z.B. kann man die Retouren eines Mailings in einem Filter selektieren und dann mit Multisource abgleichen.</p>
<p>Vor der Verwendung muss ein entsprechender Vertrag mit Multisource (directories) bestehen. Für die Historisierung (Ereignis) muss der Systemparameter &quot;msrc&quot; definiert werden.</p>
<p><strong>Prozedur 8.5. Abgleich von Adressen mit Multisource</strong></p>
<ol>
<li>
<p>Filter definieren</p>
<p>Für den Abgleich der Adressen muss vorgängig ein Filter für die Selektion der abzugleichenden Adressen definiert werden.</p>
</li>
<li>
<p>Filter markieren</p>
<p>Der definierte Filter muss für den Export vorher markiert sein.</p>
</li>
<li>
<p>Aktualisierungsdienst auswählen</p>
<p>Für den Abgleich der Adressen mit Multisource muss unter Adressaktualisierung der Aktualisierungsdienst Multisource ausgewählt werden.</p>
</li>
<li>
<p>Filter auswählen</p>
<p>Vorgängig definierten Filter auswählen</p>
</li>
<li>
<p>Job für Export der Adressen starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> wählen.</p>
</li>
<li>
<p>Adressen exportieren</p>
<p>Mit OK werden die im Filter enthaltenen Adressen in eine File exportiert, siehe Exportdatei.</p>
</li>
<li>
<p>Adressen abgleichen</p>
<p>Der Abgleich wird ausserhalb von funtrade durchgeführt.</p>
</li>
<li>
<p>Job für Import der Abgleichsresultate starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink> wählen.</p>
</li>
<li>
<p>Abgleichsresultate importieren</p>
<p>Im Feld &quot;Abgleichsresultat&quot; das Abgleichsfile von Multisource wählen.</p>
<p>Mit OK werden die Importdateien (abgeglichene Adressen) importiert.</p>
<p>Mit dem Switch &quot;Einlesen&quot; können die Files als Test zur Kontrolle oder definitiv eingelesen werden.</p>
</li>
</ol>
</div></template>


